const item = state => state.item
const items = state => state.items

export default {
  item,
  items
}
